import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { default as Star } from 'core/icons/StarFull';

export const LogoLink = styled.a`
	margin-right: auto;
`;

export const CouponsCta = styled.a`
	width: 100%;
	display: block;
	text-align: center;
	color: ${getColor("gray")};
	background: none;
	font-size: 16px;

	&:hover, &:focus {
		background-color: transparent;
		color: ${getColor('black')};
	}

	svg {
		margin-right: 4px;
		fill: ${getColor('salmon')};
	}
`;

export const StarIcon = styled(Star)`
	vertical-align: text-bottom;
`;
